
const TestCaseValue = ({ children }: any) => {

    return <span style={{ fontStyle: "italic" }}>{children}</span>
}

export default TestCaseValue;